import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';

export const EXTERNAL_TYPE = 'external';
export const IFRAME_TYPE = 'iframe';
export const IMAGE_TYPE = 'image';
export const PSD_TYPE = 'psd';
export const VIDEO_TYPE = 'video';
export const AUDIO_TYPE = 'audio';
export const ARTICLE_TYPE = 'article';
export const FOLDER_TYPE = 'folder';
export const DOCUMENT_TYPE = 'application';

export const IMAGE_WRAPPER_TAG = 'ne-image-wrapper';

export const isFolder = (contentType) => Boolean(contentType === FOLDER_TYPE);

export const isFileExternalSource = (fileType) =>
  Boolean(fileType === EXTERNAL_TYPE);

export const isFileAnArticle = (fileType) => Boolean(fileType === ARTICLE_TYPE);

export const isFileAnExternalVideo = (embed, fileType) =>
  Boolean(isFileExternalSource(fileType) && embed?.includes(IFRAME_TYPE));

export const isFileAnExternalImage = (embed, fileType) =>
  Boolean(isFileExternalSource(fileType) && embed?.includes(IMAGE_WRAPPER_TAG));

export const isFileAnImage = (url, contentType, extension) =>
  Boolean(url && contentType?.includes(IMAGE_TYPE) && extension !== PSD_TYPE);

export const hasFileAPreview = (url, contentType) =>
  Boolean(url && !contentType?.includes(IMAGE_TYPE));

export const isFileAnImageOrHasAPreview = (url, contentType, extension) =>
  isFileAnImage(url, contentType, extension) ||
  hasFileAPreview(url, contentType);

export const isFileAVideo = (fileType) =>
  Boolean(fileType?.includes(VIDEO_TYPE));

export const isFileAnAudio = (fileType) => Boolean(fileType === AUDIO_TYPE);

export const isFileADesktopVideo = (fileType) =>
  isFileAVideo(fileType) && !mobileDeviceFromUserAgent.any();

export const isFileAMobileVideo = (fileType) =>
  Boolean(isFileAVideo(fileType) && mobileDeviceFromUserAgent.any());

export const shouldOpenFileWithBlank = (fileType) =>
  isFileExternalSource(fileType) && !mobileDeviceFromUserAgent.any();

export const canDownloadFile = ({ fileType }) =>
  !isFileExternalSource(fileType) && !isFileAnArticle(fileType);

export const setFileTypeArticleOrFile = (fileType) =>
  fileType === ARTICLE_TYPE ? 'Article' : 'MediaCenter::File';
